import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../../Common/InputText';
import ImageChooser from '../../../Common/ImageChooser/ImageChooser';
import ColorChooser from '../../../Common/ColorChooser';
import { API_ROOT } from '../../../../helpers/apiConfig';
import { PUBLIC_IMAGE_URL } from '../../../../constants/constants';

export const AccountDetailsSection = (props) => {
	const onLogoColorChange = (hex) => {
		props.onFormChange('logoColor', hex);
	};

	const onLogoImageChange = (file) => {
		props.onFormChange('logoToUpload', file);
	};

	const className = props.isFormValid ? 'needs-validation' : 'needs-validation was-validated';
	const imgUrl = API_ROOT + PUBLIC_IMAGE_URL + props.imageUrl;

	return (
		<div className='account-details-section section'>
			<form className={className} noValidate>
				<div className='row mb-4'>
					<div className='col-12 col-md-4'>
						<h4>Account Details</h4>
						<p>Your company’s branding and current billing plan.</p>
					</div>
					<div className='col-12 col-md-8'>
						<div className='row gy-3'>
							<div className='col-12 col-lg-6'>
								<InputText
									bootstrapClass='w-100'
									name='subscriptionName'
									label='Subscription Name'
									placeholder='Subscription Name'
									type='text'
									value={props.subscription.name}
									isDisabled
								/>
								<InputText
									bootstrapClass='w-100 mt-3'
									name='billingPlan'
									label='Billing Plan'
									placeholder='Billing Plan'
									type='text'
									value={props.subscription.billingPlan}
									isDisabled
								/>
								<InputText
									bootstrapClass='w-100 mt-3'
									name='totalInflightTasks'
									label='Total Inflight Tasks'
									placeholder='Total Inflight Tasks'
									type='number'
									value={props.subscription.totalInflightTasks.toString()}
									isDisabled
								/>
								<a href='mailto:support@getpacer.com' className='mt-3 d-block'>
									Change Billing
								</a>
							</div>
							<div className='col-12 col-lg-6'>
								<div className='mb-3'>
									<ColorChooser
										title='Logo Background Color'
										name='logoColor'
										selectedColor={props.subscription.logoColor}
										onChange={onLogoColorChange}
									/>
								</div>
								<div>
									<ImageChooser
										name='logo'
										title='Upload Subscription Logo'
										onChange={onLogoImageChange}
										backgroundColor={props.subscription.logoColor}
										imageUrl={imgUrl}
										defaultImage={imgUrl}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	);
};

AccountDetailsSection.propTypes = {
	subscription: PropTypes.object.isRequired,
	isFormValid: PropTypes.bool.isRequired,
	onFormChange: PropTypes.func.isRequired,
	logoImage: PropTypes.string,
	imageUrl: PropTypes.string,
};

export default AccountDetailsSection;
